import type { LanguageCode } from '../types/entryRules.types';

export const LANGUAGE_TABS: { code: LanguageCode; label: string }[] = [
  { code: 'ru', label: 'Русский' },
  { code: 'kz', label: 'Қазақша' },
  { code: 'en', label: 'English' },
];

export interface LanguageLabels {
  country: string;
  ruleText: string;
  placeholder: string;
  save: string;
  saved: string;
  unsaved: string;
  newCountry: string;
  delete: string;
  deleteConfirmTitle: string;
  deleteConfirmText: string;
  deleteConfirmButton: string;
  cancel: string;
}

export const UI_LABELS: Record<LanguageCode, LanguageLabels> = {
  ru: {
    country: 'Страна',
    ruleText: 'Текст правила въезда',
    placeholder: 'Введите текст правила въезда...',
    save: 'Сохранить',
    saved: 'Сохранено',
    unsaved: 'Есть несохранённые изменения',
    newCountry: 'Новая страна',
    delete: 'Удалить',
    deleteConfirmTitle: 'Удалить правило въезда?',
    deleteConfirmText: 'Это действие нельзя отменить. Правило въезда для страны будет удалено.',
    deleteConfirmButton: 'Удалить',
    cancel: 'Отмена',
  },
  kz: {
    country: 'Ел',
    ruleText: 'Кіру ережесінің мәтіні',
    placeholder: 'Кіру ережесінің мәтінін енгізіңіз...',
    save: 'Сақтау',
    saved: 'Сақталды',
    unsaved: 'Сақталмаған өзгерістер бар',
    newCountry: 'Жаңа ел',
    delete: 'Жою',
    deleteConfirmTitle: 'Кіру ережесін жою керек пе?',
    deleteConfirmText: 'Бұл әрекетті болдырмау мүмкін емес. Елдің кіру ережесі жойылады.',
    deleteConfirmButton: 'Жою',
    cancel: 'Бас тарту',
  },
  en: {
    country: 'Country',
    ruleText: 'Entry rule text',
    placeholder: 'Enter entry rule text...',
    save: 'Save',
    saved: 'Saved',
    unsaved: 'Unsaved changes',
    newCountry: 'New country',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete entry rule?',
    deleteConfirmText: 'This action cannot be undone. The entry rule for this country will be permanently deleted.',
    deleteConfirmButton: 'Delete',
    cancel: 'Cancel',
  },
};
